import "./App.css";
import image from "./images.jpg";
import Header from "./files/header.js";
import "./files/header.css";
import Navigation from './files/navigation.js';
import Footer from './files/footer.js';


export default function App() {
  return (
    <div>
      <Header/>
      <Navigation/>
      <Footer/>
  </div>
  );
}
